var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-login"},[_c('MoleculeLogin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }